import React, { useState, useEffect } from "react";
import "./stiluri/PaginaSetari.css";
import { useTranslation } from "react-i18next";

const PaginaSetari = ({ onLogout }) => {
  const { i18n, t } = useTranslation();

  // ==== STATE-URI ====
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });

  const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
    return localStorage.getItem("notificationsEnabled") === "true";
  });

  const [fontSize, setFontSize] = useState(() => {
    return parseInt(localStorage.getItem("fontSize")) || 16;
  });

  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("lang") || "ro";
  });

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");

  // ==== EFECTE ====
  // La mount → setează limba din localStorage
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [i18n, language]);

  // Dark mode
  useEffect(() => {
    if (darkMode) document.body.classList.add("dark-mode");
    else document.body.classList.remove("dark-mode");
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // Notifications
  useEffect(() => {
    localStorage.setItem("notificationsEnabled", notificationsEnabled);
  }, [notificationsEnabled]);

  // Font size
  useEffect(() => {
    localStorage.setItem("fontSize", fontSize);
    document.documentElement.style.fontSize = `${fontSize}px`;
  }, [fontSize]);

  // ==== FUNCȚII ====
  const handleChangePassword = (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordSuccess("");

    if (password.length < 6) {
      setPasswordError(t("passwordTooShort"));
      return;
    }
    if (password !== passwordConfirm) {
      setPasswordError(t("passwordsDontMatch"));
      return;
    }

    setPassword("");
    setPasswordConfirm("");
    setPasswordSuccess(t("passwordChangedSuccess"));
  };

  const handleLanguageChange = (e) => {
    const lang = e.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-titlu">
        <h2>{t("settings")}</h2>
      </div>

      {/* DARK MODE */}
      <section className="dashboard-setare-item">
        <label>
          <input
            type="checkbox"
            checked={darkMode}
            onChange={() => setDarkMode(!darkMode)}
          />
          {t("darkMode")}
        </label>
      </section>

      {/* NOTIFICATIONS */}
      <section className="dashboard-setare-item">
        <label>
          <input
            type="checkbox"
            checked={notificationsEnabled}
            onChange={() => setNotificationsEnabled(!notificationsEnabled)}
          />
          {t("notificationsEnabled")}
        </label>
      </section>

      {/* FONT SIZE */}
      <section className="dashboard-setare-item">
        <label>
          {t("fontSize")}: {fontSize}px
          <input
            type="range"
            min="12"
            max="24"
            value={fontSize}
            onChange={(e) => setFontSize(parseInt(e.target.value))}
          />
        </label>
      </section>

      {/* SCHIMBARE PAROLA */}
      <section className="dashboard-setare-item">
        <h3>{t("changePassword")}</h3>
        <form onSubmit={handleChangePassword}>
          <input
            type="password"
            placeholder={t("newPassword")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="dashboard-input"
          />
          <input
            type="password"
            placeholder={t("confirmPassword")}
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            className="dashboard-input"
          />
          <button type="submit" className="dashboard-btn">
            {t("changePassword")}
          </button>
        </form>
        {passwordError && <p className="dashboard-eroare">{passwordError}</p>}
        {passwordSuccess && (
          <p className="dashboard-success">{passwordSuccess}</p>
        )}
      </section>

      {/* LIMBA */}
      <section className="dashboard-setare-item">
        <label>
          {t("language")}: 
          <select
            value={language}
            onChange={handleLanguageChange}
            style={{ marginLeft: "10px" }}
          >
            <option value="ro">Română</option>
            <option value="en">English</option>
          </select>
        </label>
      </section>

      {/* LOGOUT */}
      <section className="dashboard-setare-item">
        <button
          onClick={onLogout}
          className="dashboard-btn dashboard-buton-logout"
        >
          {t("logout")}
        </button>
      </section>
    </div>
  );
};

export default PaginaSetari;